import React, { useState, useEffect } from "react";
import { Typography, useMediaQuery, useTheme } from "@mui/material/";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useAuthContext } from "../../context/authcontext";
import GridDX from "../layout/griddx";
import Profile from "./profile";
import DiscTextFieldDX from "../controls/discrepency/disctextfielddx";
import content from "./riskprofilecontent.json";

const RiskProfile = (props: any) => {
  const { getUserDetails, inDiscrepancyMode, isDiscrepantField } =
    useAuthContext();

  const theme = useTheme();
  const useMobileView = useMediaQuery(theme.breakpoints.down("xs"));

  const [userProfiles, setUserProfiles] = useState<any>([]);
  const [totalScore, setTotalScore] = useState(0);
  const [riskProfile, setRiskProfile] = useState("");
  const [investorProfile, setInvestorProfile] = useState("");
  const [allocationScheme, setAllocationScheme] = useState("");

  const assignRiskProfile = (score: number) => {
    if (score >= 50) setRiskProfile("High");
    else if (score >= 36 && score < 50) setRiskProfile("Medium");
    else setRiskProfile("Low");
  };

  const assignInvestorProfile = (score: number) => {
    if (score >= 50) setInvestorProfile("Aggressive");
    else if (score >= 36 && score < 50) setInvestorProfile("Stable");
    else setInvestorProfile("Conservative");
  };

  const assignAllocationScheme = (score: number) => {
    if (score >= 50) setAllocationScheme("High Volatility");
    else if (score >= 36 && score < 50)
      setAllocationScheme("Medium Volatility");
    else setAllocationScheme("Low Volatility or Lower Volatility");
  };

  const calculateScore = (profiles: any) => {
    let score = 0;
    profiles.forEach((element: any) => {
      if (element.selectedOption) {
        let found = element.options.find(
          (opt: any) => opt.id == element.selectedOption
        );
        if (found) {
          score += found.score;
        }
      }
    });
    assignRiskProfile(score);
    assignInvestorProfile(score);
    assignAllocationScheme(score);
    setTotalScore(score);
    return score;
  };

  const onValueSelect = (index: number, e: any) => {
    let newProfile = [
      ...userProfiles.slice(0, index),
      { ...userProfiles[index], selectedOption: e.target.value },
      ...userProfiles.slice(index + 1),
    ];
    setUserProfiles(newProfile);
    let totalScore = calculateScore(newProfile);
    props.onChangeAction(newProfile, totalScore);
  };

  useEffect(() => {
    if (props.data?.riskProfile) {
      let prof = JSON.parse(props.data.riskProfile);
      setUserProfiles(prof);
      calculateScore(prof);
    }
  }, [props.data]);

  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      {userProfiles && (
        <GridDX container>
          <GridDX item container xs={12}>
            {userProfiles.map((profile: any) => {
              return (
                <GridDX
                  item
                  xs={12}
                  style={{ border: "1px solid", borderCollapse: "collapse" }}
                >
                  <Profile
                    content={profile}
                    data={props.data}
                    readOnly={true}
                  />
                </GridDX>
              );
            })}
          </GridDX>
          <GridDX container item mt={4} xs={12}>
            <GridDX item xs={3}>
              <Typography color="primary">Total Score: </Typography>
              <Typography> {totalScore}</Typography>
            </GridDX>
            <GridDX item xs={3}>
              <Typography color="primary">Risk Profile: </Typography>
              <Typography> {riskProfile}</Typography>
            </GridDX>
            <GridDX item xs={3}>
              <Typography color="primary">Investor Profile: </Typography>
              <Typography>{investorProfile}</Typography>
            </GridDX>
            <GridDX item xs={3}>
              <Typography color="primary">Allocation Scheme: </Typography>
              <Typography>{allocationScheme}</Typography>
            </GridDX>
          </GridDX>
        </GridDX>
      )}
    </LocalizationProvider>
  );
};

export default RiskProfile;
